/// <summary>
/// This object provides client-side functions for filter object based on the selectize.js tag system <br/>
/// In the filter input every filter expression gets converted to a 'tag' which can be used for any filtering. 
/// Any html div can get instanciated as filter by:<br/>
/// $(".vc-xx").vcFilter({ callback: function () { myChangeEventFunction() } });<br/>
/// The callback function is fired on any change in the filter input!<br/>
/// $(".vc-xx").vcWizard("getFilter") will return a list of filter expressions (tags)<br/>
/// <br/>
/// Note - the height of the vcFilter is fixed!!! The width is taken form the outside html div!!!<br/>
/// <br/>
/// Author: AFU<br />
/// Date: 15.2.2017<br />
/// Copyright ©: EUDT GmbH 2017 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 2.8.2017                                                *<br />
/// **********************************************************************<br />
/// * - refactored to a jQuery.widget                                    *<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 15.2.2017                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.vcFilter", {
   
    options: {
        parameter: null,
        //settings object of the current instance
        callback: function() {} 
    },
  
    _create: function () {
        var sTmp;
      
        //add the filter class to the given div
        if (this.element.hasClass("vc-filter") === false) { this.element.addClass("vc-filter"); }

        sTmp = "<div class='floatbox'>";
        sTmp += "<div class='vc-filter-prefix'><i class='fa fa-magnifying-glass color-font-secondary'></i></div>";
        sTmp += "<input class='vc-filter-input' />";
        sTmp += "</div>";
            
        this.element.html(sTmp);
        this.element.find(".vc-filter-input").width(parseInt(this.element.width(),10) - parseInt(this.element.find(".vc-filter-prefix").outerWidth(),10) -10);

       this._initInput();
        return this;
    },

    getFilter: function () {
           
        var filter = this._getFilter();
        if (filter.length > 0) {
            filter = filter.substring(0, filter.length - 1);
            filter = filter.split(",");
        } else {
            filter = null;
        }
        return filter;
    },
    add: function () {
        if (this.options.parameter !== null) {
            if (this.options.parameter.length > 0) {
                this.element.find(".vc-filter-input")[0].selectize
                    .addOption({ value: this.options.parameter, text: this.options.parameter });
                this.element.find(".vc-filter-input")[0].selectize.addItem(this.options.parameter);
            }
        }
    },

    //create the input field and add the change event handlers
    _initInput: function () {
        var me = this;
        this.element.find(".vc-filter-input")
                .selectize({
                    delimiter: ',',
                    persist: false,
                    create: function (input) {
                        me.options.callback();
                        return {
                            value: input,
                            text: input
                        };
                    },
                    onChange: function () {  me.options.callback(); }
            });
    },
    //returns a list of filter expressions
    _getFilter: function () {
           
        var val = "";
        this.element.find(".vc-filter-input .item").each(function () {
            val += $(this).html() + ",";
        });
           
        // the last comma is too much - lazy boy ;-)
        return val;
    },

    
    _destroy: function () {
        this.element
            .removeClass("vc-filter")
            .html("");
    },

    setWidth: function (width) {
        this.element.find(".vc-filter-input").width(parseInt(width, 10) - parseInt(this.element.find(".vc-filter-prefix").outerWidth(), 10) - 10);
    }

});